import React from 'react';
import { Tracking } from '~/lib/types/tracking-types';
import { CardContainer, P2GGrid, P2GText, useP2GMediaQueryDown } from '@parcel2go/core-ui';
import { useTenant } from '@parcel2go/npm-p2g-app';
import { P2GServiceLogo } from '@parcel2go/core-ui';
import { Trans, useTranslation } from 'react-i18next';
import { PublicSettings } from '~/lib/ui-serverless-settings';
import { TranslationNamespaces } from '~/lib/constants';

interface IOrderHeaderProps {
  tracking: Tracking;
  onValidate: (value: string) => void;
  authenticated: boolean;
  signIn: () => void;
  openValidation: boolean;
  onCloseValidation: () => void;
  onOpenValidation: () => void;
}

const OrderHeader: React.FC<IOrderHeaderProps> = (props) => {
  const isBreak = useP2GMediaQueryDown('xs');
  const profile = useTenant();
  const prefix = profile.settings[PublicSettings.PREFIX];
  const { t } = useTranslation(TranslationNamespaces.TRACKING);
  const tracking = props.tracking;
  const order = tracking.order;

  return (
    <CardContainer>
      <P2GGrid
        container
        direction={!isBreak ? 'row' : 'column'}
        justify="space-between"
        alignItems="center"
        spacing={1}
      >
        <P2GGrid item>
          <P2GServiceLogo slug={tracking.order.service.serviceSlug} width={122} size="small" />
        </P2GGrid>
        <P2GGrid item>
          <P2GText variant="subtitle1">
            <Trans t={t} i18nKey="RESULT_ORDER_ORDERNUMBER">
              Order Number:
            </Trans>{' '}
          </P2GText>
          {profile.settings && prefix && <P2GText variant="subtitle1">{prefix}</P2GText>}
          {(!profile.settings || !prefix) && (
            <React.Fragment>
              <P2GText colour="secondary" variant="subtitle1">
                <Trans t={t} i18nKey="RESULT_ORDER_ORDERLINEID" defaults="ID" />
              </P2GText>
              &nbsp;
            </React.Fragment>
          )}
          <P2GText variant="subtitle1">{order.orderLineId}</P2GText>
        </P2GGrid>
      </P2GGrid>
    </CardContainer>
  );
};

export default OrderHeader;
